// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b9214284","453":"ed2822b5","455":"6ec66592","977":"454447b0"}[chunkId] + ".chunk.js";
};